import React, { useState } from 'react'
import APIRefBlockDefSwagger from './APIRefBlockDefSwagger'
import styles from './swagger-api.module.css'
import classnames from 'classnames'
import { orderBy } from 'lodash'
import {
  parseMarkdown,
  isDeprecated,
  hasDeprecatedFields,
} from '../../../lib/api-utils'
import CollapseButton from './CollapseButton'
import HideDeprecatedCheckbox from './HideDeprecatedCheckbox'

export default function APIRefBlockSwagger({
  parameters,
  transaction,
  transactionTitle,
  preamble,
  opName,
  transactionId,
}) {
  const [isOpen, setIsOpen] = useState(true)
  const [checked, setChecked] = useState(false)

  const handleClick = () => setChecked(!checked)

  if ((!parameters || parameters.length === 0) && transaction !== 'response') {
    return null
  }
  let opNameModified = opName.replace(/\_/g, '-')
  if (transaction === 'requestBody') {
    parameters = parameters.map((param) => {
      return param.requestBody_content
    })
  }

  if (transaction === 'response' && parameters) {
    parameters = parameters.map((param) => {
      return param.response_content
    })
  }

  let transactionBlock = null
  if (transaction) {
    parameters = orderBy(parameters, ['required', 'name'])

    transactionBlock = parameters.map((parameter, index) => {
      let item = null

      if (checked && isDeprecated(parameter)) {
        item = null
      } else {
        item = (
          <li className="dax-def-item" key={index}>
            <APIRefBlockDefSwagger block="block" parameter={parameter} />
          </li>
        )
      }

      return item
    })
  }

  let preambleBody = null
  if (preamble) {
    let normalizedHTML = parseMarkdown(preamble)
    preambleBody = (
      <div
        className="dax-preamble"
        dangerouslySetInnerHTML={{ __html: normalizedHTML }}
      />
    )
  }

  return (
    <div data-cy={`${opNameModified}-${transactionId}`}>
      <header
        className="dax-topic-reference"
        id={`${opNameModified}-${transactionId}`}
      >
        <div className={classnames('dx-flex', styles.attributesHeading)}>
          <h4 className="dx-anchor">
            <a
              className="dx-anchor__icon"
              href={`#${opNameModified}-${transactionId}`}
              aria-hidden="true"
            />
            {transactionTitle}
          </h4>
          <CollapseButton onClick={() => setIsOpen(!isOpen)} isOpen={isOpen} />
        </div>
        {isOpen && (
          <>
            {preambleBody}
            {hasDeprecatedFields(parameters) && (
              <HideDeprecatedCheckbox onClick={handleClick} checked={checked} />
            )}
          </>
        )}
      </header>
      {isOpen && (
        <ul
          data-cy={`${opNameModified}-${transactionId}-def-list`}
          className="dax-def-list"
        >
          {transactionBlock}
        </ul>
      )}
    </div>
  )
}
